"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannersApi = void 0;
var tslib_1 = require("tslib");
var http_1 = require("@wix/ambassador-dealer-v1-banner/http");
var dealer_common_1 = require("@wix/dealer-common");
var HttpClient_1 = require("../HttpsClientApi/HttpClient");
var services_url_1 = require("../HttpsClientApi/services-url");
var externalDomains_1 = require("../externalDomains");
exports.BannersApi = {
    getBanners: function (params, experiments) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            if (experiments['specs.dealerClient.useBannerTemplate'] === 'true') {
                if (externalDomains_1.isDeviantArtDomain(params.additionalParams)) {
                    return [2 /*return*/, exports.BannersApi.getBannersFromBannersServiceProxy(params, externalDomains_1.ExternalDomains.DEVIANT_ART)];
                }
                return [2 /*return*/, exports.BannersApi.getBannersFromBannersService(params)];
            }
            return [2 /*return*/, exports.BannersApi.getBannersFromOffersServing(params)];
        });
    }); },
    getBannersFromOffersServing: function (params) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var listOffersRequest;
        var _a;
        return tslib_1.__generator(this, function (_b) {
            listOffersRequest = {
                realEstateId: params.bannerPositions[0],
                limit: params.limit,
                excludeOfferIds: params.excludeLightboxes,
            };
            if (!params.signedInstance && params.metasiteGuid) {
                listOffersRequest['extensions.siteId'] = params.metasiteGuid;
            }
            if ((_a = params.additionalParams) === null || _a === void 0 ? void 0 : _a.deviantArtUserId) {
                listOffersRequest.deviantArtUserId =
                    params.additionalParams.deviantArtUserId;
            }
            return [2 /*return*/, HttpClient_1.HttpClientApi.doGet(services_url_1.OFFERS_SERVING, listOffersRequest, params.signedInstance ? { Authorization: params.signedInstance } : {}).then(function (_a) {
                    var data = _a.data;
                    return exports.BannersApi.ListOffersResponseToDealerDataResponse(data);
                })];
        });
    }); },
    getBannersFromBannersService: function (params) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var request, data;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = exports.BannersApi.getServeBannersRequest(params);
                    return [4 /*yield*/, HttpClient_1.HttpClientApi.doRequest(http_1.serveBanners, request, params.signedInstance ? { Authorization: params.signedInstance } : {})];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, exports.BannersApi.ServeBannersResponseToDealerDataResponse(data)];
            }
        });
    }); },
    getBannersFromBannersServiceProxy: function (params, domain) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var request, url, data;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = exports.BannersApi.getServeBannersRequest(params);
                    url = services_url_1.getBannersServiceProxyUrl(domain);
                    return [4 /*yield*/, HttpClient_1.HttpClientApi.doGet(url, request, params.signedInstance ? { Authorization: params.signedInstance } : {})];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, exports.BannersApi.ServeBannersResponseToDealerDataResponse(data)];
            }
        });
    }); },
    ListOffersResponseToDealerDataResponse: function (data) {
        if (!data || !data.offers || data.offers.length === 0) {
            return [];
        }
        return data.offers.map(function (offer) {
            var bannerData = dealer_common_1.convertOfferToBannerData(offer);
            return tslib_1.__assign({ asset: bannerData }, bannerData);
        });
    },
    ServeBannersResponseToDealerDataResponse: function (data) {
        if (!data || !data.banners || data.banners.length === 0) {
            return [];
        }
        return data.banners.map(function (banner) {
            var bannerData = dealer_common_1.convertBannerToBannerData(banner);
            return tslib_1.__assign({ asset: bannerData }, bannerData);
        });
    },
    getServeBannersRequest: function (params) {
        var _a;
        var request = {
            placementId: params.bannerPositions[0],
        };
        if (params.limit) {
            request.limit = params.limit;
        }
        if (params.excludeLightboxes) {
            request.excludeOfferIds = params.excludeLightboxes;
        }
        if (!params.signedInstance && params.metasiteGuid) {
            request.metaSiteId = params.metasiteGuid;
        }
        if ((_a = params.additionalParams) === null || _a === void 0 ? void 0 : _a.deviantArtUserId) {
            request.deviantArtUserId = params.additionalParams.deviantArtUserId;
        }
        return request;
    },
};
//# sourceMappingURL=BannersApi.js.map